import { useConfig } from '../context/ConfigContext';
import { formatMoney } from '../utils/currencyUtil';

/**
 * One add-on row on the pricing card: a + to add, a − and count once added,
 * and the price — per unit until something is added, then the running total.
 *
 * @param {object} props
 * @param {string} props.label - e.g. 'Add staff accounts'
 * @param {string} props.itemName - for the +/− labels, e.g. 'staff account'
 * @param {number} props.qty
 * @param {number} props.max
 * @param {number} props.price - per unit
 * @param {string} props.unitLabel - shown after the unit price, e.g. '/staff'
 * @param {(qty: number) => void} props.onChange
 * @param {React.ReactNode} props.children - the line under the row
 * @returns {JSX.Element}
 */
function PosLandingAddon({
  label, itemName, qty, max, price, unitLabel, onChange, children,
}) {
  const { config } = useConfig();
  const maxed = qty >= max;

  return (
    <div className={`addon${qty > 0 ? ' on' : ''}`}>
      <div className="addon-row">
        <button
          type="button"
          className={`addon-ico${maxed ? ' maxed' : ''}`}
          aria-label={`Add one ${itemName}`}
          disabled={maxed}
          onClick={() => onChange(Math.min(max, qty + 1))}
        >
          +
        </button>
        <b>{label}</b>
        <span className="addon-count" hidden={qty === 0}>
          <button
            type="button"
            className="cnt-btn"
            aria-label={`Remove one ${itemName}`}
            onClick={() => onChange(Math.max(0, qty - 1))}
          >
            &minus;
          </button>
          <span className="cnt-n">×{qty}</span>
        </span>
        <span className="addon-price">
          {qty > 0 ? formatMoney(price * qty, config) : formatMoney(price, config)}
          <em>{qty > 0 ? ' /month' : ` ${unitLabel}`}</em>
        </span>
      </div>
      {children}
    </div>
  );
}

export default PosLandingAddon;
